import { pageNames, Path, Permission } from 'router/constant';
import { ReactComponent as DashboardIcon } from 'assets/icons/dashboard.svg';
import { ReactComponent as PullRequestIcon } from 'assets/icons/git-pull-request.svg';
import { ReactComponent as SettingsIcon } from 'assets/icons/uil_setting.svg';
import { ReactComponent as IssueIcon } from 'assets/icons/git-issue.svg';
import { ReactComponent as WorkflowIcon } from 'assets/icons/git-workflow.svg';
import { ReactComponent as SecretsIcon } from 'assets/icons/secretsIcon.svg';
import { ReactComponent as DeploymentVersionsIcon } from 'assets/icons/deployment.svg';
import { ReactComponent as ConnectionsIcon } from 'assets/icons/connection.svg';
import { ReactComponent as ClustersIcon } from 'assets/icons/connection-pattern.svg';
import { ReactComponent as ServicesIcon } from 'assets/icons/cluster-icon.svg';
import { ISideNavigationItems } from 'interface/commonInterface';

export const sideNavigationItems: ISideNavigationItems[] = [
  {
    name: 'Dashboard',
    path: Path.DASHBOARD,
    key: 'dashboard',
    icon: DashboardIcon,
    permissionKey: Permission.DASHBOARD,
    pageName: pageNames.DASHBOARD,
  },
  {
    name: 'Services',
    path: Path.SERVICES,
    key: 'services',
    icon: ServicesIcon,
    permissionKey: Permission.SERVICES,
    pageName: pageNames.SERVICES,
  },
  {
    name: 'Workflows',
    path: Path.WORKFLOWS,
    key: 'workflows',
    icon: WorkflowIcon,
    permissionKey: Permission.WORKFLOWS,
    pageName: pageNames.WORKFLOWS,
  },
  {
    name: 'Connections',
    path: Path.CONNECTIONS,
    key: 'connections',
    icon: ConnectionsIcon,
    permissionKey: Permission.CONNECTIONS,
    pageName: pageNames.CONNECTIONS,
    children: [
      {
        name: 'Clusters',
        path: Path.CLUSTERS,
        key: 'clusters',
        icon: ClustersIcon,
        pageName: pageNames.CLUSTERS,
      },
    ],
  },
  {
    name: 'Deployment Versions',
    path: Path.DEPLOYMENT_VERSIONS,
    key: 'deploymentVersions',
    icon: DeploymentVersionsIcon,
    permissionKey: Permission.DEPLOYMENT_VERSIONS,
    pageName: pageNames.DEPLOYMENT_VERSIONS,
  },
  {
    name: 'Pull Requests',
    path: Path.PULL_REQUESTS,
    key: 'pullRequests',
    icon: PullRequestIcon,
    permissionKey: Permission.PULL_REQUESTS,
    pageName: pageNames.PULL_REQUESTS,
  },
  {
    name: 'Issues',
    path: Path.ISSUES,
    key: 'issues',
    icon: IssueIcon,
    permissionKey: Permission.ISSUES,
    pageName: pageNames.ISSUES,
  },
  {
    name: 'Secrets',
    path: Path.SECRETS,
    key: 'secrets',
    icon: SecretsIcon,
    permissionKey: Permission.SECRETS,
    pageName: pageNames.SECRETS,
  },
  {
    name: 'Settings',
    path: Path.SETTINGS,
    key: 'newSettings',
    icon: SettingsIcon,
    permissionKey: Permission.SETTINGS,
    pageName: pageNames.SETTINGS,
  },
];

export const headerDetails = {
  [Path.DASHBOARD]: {
    display: 'Dashboard',
  },

  [Path.SERVICES]: {
    display: 'Services',
  },

  [Path.ADMIN_USERS]: {
    display: 'Users',
  },

  [Path.PULL_REQUESTS]: {
    display: 'Pull Requests',
  },

  [Path.ISSUES]: {
    display: 'Issues',
  },

  [Path.SECRETS]: {
    display: 'Secrets',
  },

  [Path.CLUSTERS]: {
    display: 'Clusters',
  },

  [Path.CLUSTER_DETAILS]: {
    display: 'Cluster Details',
  },

  [Path.WORKFLOWS]: {
    display: 'Workflows',
  },

  [Path.DEPLOYMENT_VERSIONS]: {
    display: 'Deployment Versions',
  },

  [Path.SETTINGS]: {
    display: 'Settings',
  },
};
